var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3352_39332)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 16,
    r: 16,
    fill: "#FBEC66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.744 11.984C20.392 11.984 20.0933 11.904 19.848 11.744C19.6133 11.5733 19.496 11.3227 19.496 10.992C19.496 10.5227 19.6453 10.1867 19.944 9.984C20.2427 9.78133 20.5893 9.68 20.984 9.68C21.3253 9.68 21.624 9.76 21.88 9.92C22.136 10.0693 22.264 10.3253 22.264 10.688C22.264 11.1253 22.104 11.4507 21.784 11.664C21.4747 11.8773 21.128 11.984 20.744 11.984ZM19.96 22.16C19.352 22.16 18.8827 22.016 18.552 21.728C18.2213 21.4293 18.056 21.024 18.056 20.512C18.056 20.288 18.0773 20.016 18.12 19.696C18.1627 19.376 18.2267 19.0133 18.312 18.608L18.936 15.632C18.968 15.4933 18.9947 15.3547 19.016 15.216C19.0373 15.0773 19.048 14.9867 19.048 14.944C19.048 14.656 18.984 14.4747 18.856 14.4C18.728 14.3147 18.5093 14.272 18.2 14.272H17.912L18.072 13.424H21.848L20.744 18.624C20.68 18.912 20.6267 19.184 20.584 19.44C20.5413 19.696 20.52 19.936 20.52 20.16C20.52 20.64 20.7067 20.88 21.08 20.88C21.2507 20.88 21.4053 20.848 21.544 20.784C21.6827 20.72 21.8427 20.6293 22.024 20.512L22.408 21.056C22.152 21.3227 21.8267 21.5733 21.432 21.808C21.0373 22.0427 20.5467 22.16 19.96 22.16Z",
    fill: "#083880"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3352_39332",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3352_39332"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3352_39332",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundInfo);
export default __webpack_public_path__ + "static/media/BackgroundInfo.bcd41e54f373153aceacce13e2a553b0.svg";
export { ForwardRef as ReactComponent };